Ext.define('SA.data.AttributeTypes', {
    singleton: true,

    map: {
        count: 'Count',
        mean: 'Mean',
        median: 'Median',
        percent: 'Percent'
    },

    getTypes() {
        return Object.keys(this.map);
    },

    getTextForType(type) {
        return this.map[type];
    }
});
